import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@mui/material";
import MDBox from "components/MDBox";
import AntecedenteForm from "./AntecedenteForm";
import { useMaterialUIController } from "context";

const NewAntecedente = ({
  open,
  handleClose,
  estudianteUrl,
  nombreEstudiante,
  curpEstudiante,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 600,
    boxShadow: 24,
    borderRadius: "12px",
    p: 4,
    outline: "none",
    maxHeight: "90vh",
    overflowY: "auto",
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <MDBox sx={modalStyle} bgColor={darkMode ? "black" : "white"}>
        <AntecedenteForm
          estudianteUrl={estudianteUrl}
          nombreEstudiante={nombreEstudiante}
          curpEstudiante={curpEstudiante}
          onSuccess={handleClose}
          onCancel={handleClose}
        />
      </MDBox>
    </Modal>
  );
};

NewAntecedente.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  estudianteUrl: PropTypes.string,
  nombreEstudiante: PropTypes.string,
  curpEstudiante: PropTypes.string,
};

export default NewAntecedente;
